<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link
        :to="{
        name: 'seguimientoPti',
        params: { idPti: data.item.idPti, idSolicitud: data.item.idSolicitudDiagnostico, idPaciente: data.item.idPaciente, idTipoSolicitud: data.item.idTipoSolicitud },
      }"
    >
      <p
          class="letraColorAzulPrincipal letraEstiloNegrita"
      >
        {{ data["item"].nombrePaciente }}
      </p>
    </router-link>
  </div>

</template>

<script>
export default {
  name: "BandejaLinkSeguimientoPTIComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>

<style scoped>

</style>
